import { render, staticRenderFns } from "./UserListAudits.vue?vue&type=template&id=3c07ff28&xmlns%3Ab-row=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./UserListAudits.vue?vue&type=script&lang=js&"
export * from "./UserListAudits.vue?vue&type=script&lang=js&"
import style0 from "./UserListAudits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports